import styled from 'styled-components'

export const CheckboxInput = styled.input.attrs({
	type: 'checkbox',
})`
	position: absolute;
	opacity: 0;
	pointer-events: none;
`
